module.exports = __webpack_public_path__ + "img/envelop_icon.e71f42dc.svg";